import Handler from "@/core/domain/usecase/handler";

const fetchEquipmentStatusLogRepository = (axios) => async (pagination) => {
    try {
        const response = await axios.get('/equipment-status-log', {
            params: pagination
        });

        const equipmentStatusLogPagination = response.data;
        return equipmentStatusLogPagination;
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err);
        } else {
            throw err;
        }
    }
}

export default fetchEquipmentStatusLogRepository